// @ts-check

import React, { useState } from 'react';
import Typography from '@material-ui/core/Typography';
import { useDispatch, useSelector } from 'react-redux';
import { makeStyles } from '@material-ui/core/styles';
import Box from '@material-ui/core/Box';
import Button from '@material-ui/core/Button';
import CircularProgress from '@material-ui/core/CircularProgress';
import NavigateNextIcon from '@material-ui/icons/NavigateNext';
import { sendForm } from '../formSender'
import { enrichSolutions } from './solutionsEnricher'
import { isFormValid, getMultiFieldErrors } from '../FormValidation/validationChecker'

import {
  SOLUTIONS_ARRIVED,
  SET_FORM_QUERY_SENT
} from '../../../redux/actions/actionTypes'

/**
 * limiting to 20 solutions
 */
const reduceSolutionsNumber = (solutionsRes) => {
  solutionsRes.solutions = solutionsRes?.solutions?.slice(0, 20)
}

const useStyles = makeStyles((theme) => ({
  loader: {
    position: 'absolute',
    right: '150px',
    height: '15px',
    width: '15px',
    color: 'white'
  },
  redText: {
    color: 'Red'
  }
}));

export function GoToPlootoButton(props) {
  const globalFormData = useSelector(state => state.globalFormData);
  const unitTypesState = useSelector(state => state.globalFormData?.buildingInfo?.unit_types);
  const dispatch = useDispatch()
  const styles = useStyles()

  const formValid = isFormValid(globalFormData)
  const multiFieldErrors = getMultiFieldErrors(globalFormData)

  const materialsState = useSelector(state => state.globalFormData.sustainability.materials)
  const externalWallsMaterial = materialsState.find(material => material.prefix === "EW")

  const sidesMaterial = materialsState.find(material => material.prefix === "EW").material


  const windowMaterial = materialsState.find(material => material.prefix === "WD").material

  const roofMaterial = materialsState.find(material => material.prefix === "RF").material

  localStorage.setItem('materialsState', JSON.stringify(materialsState))


  return (
    <Box marginY={1}>
      {
        !formValid && <Typography className={styles.redText}> There are invalid inputs in the form</Typography>
      }
      {
        multiFieldErrors.length > 0 && <Typography className={styles.redText}> {multiFieldErrors[0].errText}</Typography>
      }

      <Button
        disabled={!formValid}
        variant="contained"
        color="secondary"
        endIcon={<NavigateNextIcon />}
        fullWidth
        onClick={async (event) => {

          if (!formValid) {
            return
          }
          // TODO: trigger global form validation

          dispatch({
            type: SET_FORM_QUERY_SENT,
          })

          // TODO - dispatch INPUT_CHANGED event first
          localStorage.setItem('globalFormData', JSON.stringify(globalFormData))
          // debugger;
          const solutionsRes = await sendForm(globalFormData)
          reduceSolutionsNumber(solutionsRes)
          const enrichedSolutions = enrichSolutions(unitTypesState, solutionsRes)

          dispatch({
            type: SOLUTIONS_ARRIVED,
            payload: enrichedSolutions
          })
          // debugger;
          localStorage.setItem('materialUrl', externalWallsMaterial.tile_url)
          localStorage.setItem('sidesMaterial', sidesMaterial)
          localStorage.setItem('windowMaterial', windowMaterial)
          localStorage.setItem('roofMaterial', roofMaterial)
        }}>
        Go to plooto
        {globalFormData.buildingInfo.query_in_flight &&
          <CircularProgress className={styles.loader} size={20} />
        }
      </Button>

    </Box>
  )
}
